
import React from 'react';
import { TableHeader, TableRow, TableHead } from '@/components/ui/table';
import SortableTableHeader from './SortableTableHeader';
import { CustomerData } from '@/hooks/admin/types';

interface CustomerTableHeadersProps {
  handleSort: (column: keyof CustomerData) => void;
  sortColumn: keyof CustomerData;
  sortDirection: 'asc' | 'desc';
}

const CustomerTableHeaders: React.FC<CustomerTableHeadersProps> = ({
  handleSort,
  sortColumn,
  sortDirection
}) => {
  const headerColumns = [
    { key: 'name' as keyof CustomerData, label: 'Name' },
    { key: 'email' as keyof CustomerData, label: 'Email' },
    { key: 'tracksCount' as keyof CustomerData, label: 'Tracks' },
    { key: 'pageViews' as keyof CustomerData, label: 'Page Views' },
    { key: 'downloads' as keyof CustomerData, label: 'Downloads' },
    { key: 'created_at' as keyof CustomerData, label: 'Created At' },
  ];

  return (
    <TableHeader>
      <TableRow>
        {headerColumns.map(column => (
          <TableHead key={String(column.key)}>
            <SortableTableHeader
              column={column.key}
              label={column.label}
              sortColumn={sortColumn}
              sortDirection={sortDirection}
              handleSort={handleSort}
            />
          </TableHead>
        ))}
        <TableHead>Status</TableHead>
      </TableRow>
    </TableHeader>
  );
};

export default CustomerTableHeaders;
